let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
console.log(items)
items.forEach(item => {
item.addEventListener("mouseover", () => {
item.setAttribute("open", true);
item.querySelector("ul").addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
item.addEventListener("mouseleave", () => {
item.removeAttribute("open");
});
});

});
jQuery(document).ready(function($){
  $('#bannerSlider').owlCarousel({
    loop: true,
    margin: 20,
    nav: false,
    dots: false,
    autoplayTimeout:10000,
    autoplay:true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        768: {
            items: 1
        },
        1000: {
          items: 1
      },
        1366: {
            items: 1
        }
    }
    });
  
});
// script for colour swatches
jQuery(window).on('load', function () {

    const variantId = new URLSearchParams(window.location.search).get('variant');
    if (variantId) {
        initiate_swatch();
    }

});
document.addEventListener('change', function () {

    initiate_swatch();

});

function initiate_swatch(){
  

    setTimeout(() => {  

        const variant = JSON.parse(
            document.querySelector('[data-selected-variant]')
                .textContent
        );

        const images = window.variantImages[variant.id];

       // console.log('Variant:', variant.id);
        //console.log('Images:', images);

        if (!images || !images.length) {
            return;
        }

        const mainImage = document.querySelector('#mainImage');

        if (mainImage) {

            mainImage.src = 'https:' + images[0];

            mainImage.dataset.zoomImage =
                'https:' + images[0];

                const gallery =
                document.querySelector('.thumbnail-slider');

            if (!gallery) {
                return;
            }
           // jQuery('.thumbnail-slider').slick('unslick');
            gallery.innerHTML = '';
           // jQuery('.thumbnail-slider').remove();
           let galleryHtml = '';
           galleryHtml += '<div class="thumbnail-slider">';
            images.forEach((url, index) => {

                galleryHtml += `
                    <li class="product__media-item">
                        <img
                            src="https:${url}"
                            data-image-index="${index}"
                            style="cursor:pointer"
                        >
                    </li>
                `;

            });
            galleryHtml += '</div>';
            jQuery('.thumbnail-slider').replaceWith(galleryHtml);
        }
        gallery_loader(jQuery);
    }, 0);
}
function gallery_loader($){
   
    if ($('.product-container').length) {
  var $thumbnailSlider = $('.thumbnail-slider');
         //console.log('gallery loading',$thumbnailSlider.html());
if (!$('.thumbnail-slider').hasClass('slick-initialized')) {
     if ($('.thumbnail-slider').hasClass('slick-initialized')) {
        $('.thumbnail-slider').slick('unslick');
    }
    $thumbnailSlider.slick({
        vertical: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: true,
        infinite: true
    });
    $('.slick-next').html('<i class="fa fa-angle-right" aria-hidden="true"></i>');
     $('.slick-prev').html('<i class="fa fa-angle-left" aria-hidden="true"></i>');
  $thumbnailSlider.on('afterChange', function(event, slick, currentSlide) {
    const $currentSlide = $(slick.$slides[currentSlide]);

    // If the thumbnail contains a video template, inject it into the main active slide
    const $videoTemplate = $currentSlide.find('.zoom-video-template');
    if ($videoTemplate.length) {
      const $gallery = $currentSlide.closest('media-gallery');
      const $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
      if ($mainActive.length) {
        window.pauseAllMedia && window.pauseAllMedia();
        $mainActive.empty().append($videoTemplate.html());
      }
      return;
    }

    // Fallback: if data-zoom-video-url is provided, inject iframe
    const zoomVideoUrl = $currentSlide.attr('data-zoom-video-url') || $currentSlide.find('img').attr('data-zoom-video-url');
    if (zoomVideoUrl) {
      const $gallery = $currentSlide.closest('media-gallery');
      const $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
      if ($mainActive.length) {
        window.pauseAllMedia && window.pauseAllMedia();
        $mainActive.empty().append('<iframe src="' + zoomVideoUrl + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
      }
      return;
    }

    const newImageSrc = $currentSlide.find('img').attr('src');
    const newImageAlt = $currentSlide.find('img').attr('alt') || '';
    const $gallery = $currentSlide.closest('media-gallery');
    const $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
    if ($mainActive.length) {
      window.pauseAllMedia && window.pauseAllMedia();
      $mainActive.empty().append('<img width="" height="" src="' + newImageSrc + '" data-zoom-image="' + newImageSrc + '" alt="' + newImageAlt + '">');
    } else {
      $('.zoomed-image img').attr('src', newImageSrc).removeAttr('srcset');
    }
  });


  $('.product__media-item').each(function () {
  const $item = $(this);
  const $template = $item.find('template.zoom-video-template');

  if ($template.length && !$item.find('.zoom-video-poster-play-button').length) {

    const staticImageUrl = 'https://cdn.shopify.com/s/files/1/0662/3225/4640/files/play-btn.png?v=1766737294';


    $('<span class="zoom-video-poster-play-button">' +
        '<img src="' + staticImageUrl + '" alt="">' +
      '</span>').insertBefore($template);
  }
  });

   
    /*$thumbnailSlider.on('wheel', function(e) {
        if (e.originalEvent.deltaY > 0) {
            $(this).slick('slickNext');
        } else {
            $(this).slick('slickPrev');
        }
    });
   */
    $('.thumbnail-slider .product__media-item img').click(function() {
      var $slide = $(this).closest('.product__media-item');
      var $videoTemplate = $slide.find('.zoom-video-template');
      if ($videoTemplate.length) {
        var $gallery = $(this).closest('media-gallery');
        var $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
        if ($mainActive.length) {
          window.pauseAllMedia && window.pauseAllMedia();
          $mainActive.empty().append($videoTemplate.html());
        }
        return;
      }

      var zoomVideoUrl = $slide.attr('data-zoom-video-url') || $(this).attr('data-zoom-video-url');
      if (zoomVideoUrl) {
        var $gallery = $(this).closest('media-gallery');
        var $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
        if ($mainActive.length) {
          window.pauseAllMedia && window.pauseAllMedia();
          $mainActive.empty().append('<iframe src="' + zoomVideoUrl + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
        }
        return;
      }

      var newImageSrc = $(this).attr('src');
      var newImageAlt = $(this).attr('alt') || '';
      var $gallery = $(this).closest('media-gallery');
      var $mainActive = $gallery.find('.product__media-list .product__media-item.is-active .product__media');
      if ($mainActive.length) {
        window.pauseAllMedia && window.pauseAllMedia();
        $mainActive.empty().append('<img width="" height="" src="' + newImageSrc + '" data-zoom-image="' + newImageSrc + '" alt="' + newImageAlt + '">');
      } else {
        $('.zoomed-image img').attr('src', newImageSrc).removeAttr('srcset');
      }
    });
    }else{

       $('.thumbnail-slider').slick('refresh');
    }
  }
}

// script for custom popup modal for international customers
document.addEventListener('DOMContentLoaded', function () {

  const modal = document.getElementById('InternationalEnquiryModal');

  if (!modal) return;

  const productDisplay = document.getElementById(
    'InternationalEnquiryProductDisplay'
  );

  const productInput = document.getElementById(
    'InternationalEnquiryProduct'
  );

  const productUrlInput = document.getElementById(
    'InternationalEnquiryProductUrl'
  );

  // Open enquiry popup
  document.addEventListener('click', function (event) {

    const enquiryButton = event.target.closest('.international-enquiry-btn');

    if (!enquiryButton) return;

    event.preventDefault();

    const productTitle =
      enquiryButton.getAttribute('data-product-title') || '';

    const productUrl =
      enquiryButton.getAttribute('data-product-url') || '';

    if (productDisplay) {
      productDisplay.textContent = productTitle;
    }

    if (productInput) {
      productInput.value = productTitle;
    }

    if (productUrlInput) {
      productUrlInput.value = productUrl;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('international-enquiry-open');
  });


  // Close popup
  document.addEventListener('click', function (event) {

    if (!event.target.closest('[data-enquiry-close]')) {
      return;
    }

    closeInternationalEnquiry();
  });


  // Close popup with Escape
  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      modal.classList.contains('is-open')
    ) {
      closeInternationalEnquiry();
    }

  });


  function closeInternationalEnquiry() {

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('international-enquiry-open');

  }

});